import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const syncTz = (u) => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && u?.tz !== tz && u?.role !== "pending") api.put("/auth/profile", { tz }).catch(() => {});
  };

  useEffect(() => {
    document.documentElement.classList.toggle("a11y", localStorage.getItem("kindred_a11y") === "1");
    const token = localStorage.getItem("kindred_token");
    // Returning from Google OAuth: AuthCallback exchanges session_id first
    if (window.location.hash?.includes("session_id=") || !token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => { setUser(res.data); syncTz(res.data); })
      .catch(() => localStorage.removeItem("kindred_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("kindred_token", token);
    setUser(userData);
    syncTz(userData);
  };

  const logout = () => {
    localStorage.removeItem("kindred_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
